import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./store/store";
import "animate.css";
import "swiper/swiper-bundle.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./assets/scss/style.scss";
import "./i18n";
import { saveState } from "./helpers/persistor";

store.subscribe(() => {
  const state = store.getState();
  saveState({
    cart: state.cart,
    wishlist: state.wishlist,
    auth: state.auth,
    address: state.address,
    coupon: state.coupon,
    order: state.order,
  });
});

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
